<template>
    <div @mouseover="setMouseOver(true)" @mouseout="setMouseOver(false)" :style="widthStyles">

        <v-toolbar v-if="!disableTitle" tile dense :color="color" class="elevation-3">

            <slot name="image"></slot>

            <v-app-bar-nav-icon v-if="sideIcon">
                <v-icon>{{ sideIcon }}</v-icon>
            </v-app-bar-nav-icon>

            <v-toolbar-title class="white--text subtitle-2 pl-0">
                <div class="d-flex">

                    <div class="align-self-center">
                        {{ title }}
                        <span v-if="subTitle"> | </span>
                        <span class="caption grey--text text--lighten-1">{{subTitle}}</span>
                    </div>

                    <slot class="align-self-center" name="title"></slot>

                    <v-fade-transition>
                        <help-button v-if="help"
                                     class="ml-2 align-self-center"
                                     v-show="help && isMouseOver"
                                     :active="isMouseOver"
                                     :help="help"/>
                    </v-fade-transition>

                </div>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <slot name="buttons"></slot>

        </v-toolbar>

        <v-slide-y-transition>
            <v-card :loading="loading ? 'primary' : false"
                    tile
                    :height="innerHeight ? innerHeight : null"
                    style="border: 1px solid #616161"
                    v-show="!hideContents"
                    :color="backgroundColor"
                    :class="isMouseOver ? 'elevation-5' : 'elevation-2'">

                <v-overlay
                    :absolute="true"
                    :value="hideContents"
                    opacity="0.6"
                    class="h3"
                >
                    <slot name="overlay">
                    </slot>
                </v-overlay>

                <v-card-text :class="padding">
                    <slot></slot>
                </v-card-text>

            </v-card>
        </v-slide-y-transition>

    </div>
</template>

<script>

import HelpButton from "@/components/UI/HelpButton.vue";

export default {

    components: {
        HelpButton,
        Help: () => import('../../modules/Help/components/index.vue')
    },

    data() {
        return {
            isMouseOver: false,
            timerRunning: false,
            timer: null,
        }
    },

    props: {
        title: {
            type: String,
            required: true,
            default: 'Title attribute not specified',
        },
        subTitle: {
            type: String,
            required: false,
            default: null,
        },
        color: {
            type: String,
            required: false,
            default: '#484848'
        },
        sideIcon: {
            type: String | null,
            required: false,
            default: null
        },
        backgroundColor: {
            type: String,
            required: false,
            default: 'grey darken-2'
        },
        noPadding: {
            type: Boolean,
            required: false,
            default: false
        },
        noPaddingTop: {
            type: Boolean,
            required: false,
            default: false,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        hideContents: {
            type: Boolean,
            required: false,
            default: false,
        },
        help: {
            type: String,
            required: false,
            default: null
        },
        disableTitle: {
            type: Boolean,
            required: false,
            default: false,
        },
        innerHeight: {
            type: Number | null,
            required: false,
            default: null,
        },
        minWidth: {
            type: Number | null,
            required: false,
            default: null
        },
        maxWidth: {
            type: Number | null,
            required: false,
            default: null,
        }
    },

    computed: {
        padding() {
            if (this.noPadding) return 'pa-0';
            if (this.noPaddingTop) return 'pl-5 pr-5 pb-5 pt-0'
            return 'pa-5'
        },

        widthStyles() {
            let styles = [];
            if (this.minWidth) styles.push('min-width: ' + this.minWidth + 'px;');
            if (this.maxWidth) styles.push('max-width: ' + this.maxWidth + 'px;');
            return styles.join(' ');
        }
    },

    methods: {

        setMouseOver(bool) {

            // Use timers to fix flickering help icon
            if (bool === false) {

                if (!this.timerRunning) {
                    this.timer = setTimeout(() => {
                        this.isMouseOver = false;
                        this.timerRunning = false;
                    }, 100);
                }

                this.timerRunning = true;

            } else {

                if (this.timer) {
                    this.timerRunning = false;
                    clearTimeout(this.timer);
                }
                this.isMouseOver = true;
            }
        }
    }
}
</script>
